import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import styles from './Fact.module.scss'

export const Fact: FunctionComponent<Props> = ({
  title,
  body,
  className,
  ...rest
}) => {
  return (
    <aside
      className={classnames(styles.container, className)}
      data-testid="fact"
      {...rest}
    >
      <TypographyV2
        tag="p"
        textStyle="sb-text-heading-large"
        className={styles.title}
      >
        {title}
      </TypographyV2>

      <TypographyV2
        tag="p"
        textStyle="sb-text-interface-body-default-regular"
        className={styles.body}
      >
        {body}
      </TypographyV2>
    </aside>
  )
}

///IMPLEMENTATION////

type Props = {
  /**
   * Title for the fact/statistic.
   */
  title: string

  /**
   * Body text for the fact/statistic.
   */
  body: string

  /**
   * Optional class name for the container element.
   */
  className?: string
} & ComponentPropsWithoutRef<'aside'>
